import useApiFetch from '@/hooks/useApiFetch';
import candidatesServices from '@/services/candidates';
import { FetchApiIds } from '@/types';
import { AvgTimeToAcceptanceOrRejectionByOwnerResponse } from '@/types/api';
import { getPercentageAcceptanceRejection } from '@/utils/chart';
import AvgTimeInDaysByOwnerComponent from './AvgTimeInDaysByOwner.component';

const AvgTimeInDaysByOwnerContainer = function (): JSX.Element {
  const response = useApiFetch<AvgTimeToAcceptanceOrRejectionByOwnerResponse[]>(
    FetchApiIds.AVG_TIME_BY_OWNER,
    candidatesServices.getAvgTimeToAcceptanceOrRejectionByOwner
  );

  const data = response.data ?? [];

  const grouped = data.map((c) => {
    return [c.chart.trio, c.chart.partners];
  });
  const flat = grouped.flat();
  const biggestNumber = flat.length ? Math.max(...flat) : 0;
  const withPercentage = getPercentageAcceptanceRejection(data, biggestNumber);

  return (
    <>
      <div data-testid="avarage-time-chart">
        <AvgTimeInDaysByOwnerComponent isLoading={response.isLoading} data={withPercentage} />
      </div>
    </>
  );
};

export default AvgTimeInDaysByOwnerContainer;
